import { useQuery } from '@tanstack/react-query';
import React from 'react';

import envVars from '../../../../../constants/envVars';
import useRequest from '../../../../../hooks/useRequest';
import { portalLinkMock } from '../mockData';
import { ApiEnvelope } from '../../../types';
import { PortalLink } from '../types';
import { PORTAL_LINK_KEY } from './constants';

/** Resolves `data: null` when the member has no active link or is not linked. */
const useGetPortalLink = (member_id: number | null | undefined) => {
    const req = useRequest();

    const request = React.useCallback(() => {
        if (envVars.USE_EHR_MOCK_DATA) {
            return Promise.resolve(portalLinkMock);
        }

        return req<ApiEnvelope<PortalLink | null>>({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/member/${member_id}/portal-link/`
        });
    }, [member_id, req]);

    return useQuery({
        queryKey: [PORTAL_LINK_KEY, member_id],
        queryFn: request,
        select: (response) => response.data,
        enabled: !!member_id
    });
};

export default useGetPortalLink;
